import * as React from "react";

// Components
import { IonSpinner } from "@ionic/react";
import { Link } from "react-router-dom";

// Hooks
import { useTranslation } from "react-i18next";

export default function CardInner({ stage, loading }: { stage: any; loading: boolean }) {
  const { t } = useTranslation();

  return (
    <ul className="registration-stages__column__users">
      {loading ? (
        <IonSpinner name="dots" />
      ) : (
        <>
          {stage.users.map((user: any, index: any) => (
            <li key={index}>
              <Link to={`/admin/members/${user.id}`}>{user.member?.nickname || `${t("member")} ${user.id}`}</Link>
            </li>
          ))}

          {stage.users.length === 0 && <span className="registration-stages__message registration-stages__message--no-results">{t("noUsersToShow")}</span>}
        </>
      )}
    </ul>
  );
}
